import { render, staticRenderFns } from "./StarterPackCommControlBlock.vue?vue&type=template&id=190651dc&scoped=true"
import script from "./StarterPackCommControlBlock.vue?vue&type=script&lang=js"
export * from "./StarterPackCommControlBlock.vue?vue&type=script&lang=js"
import style0 from "./StarterPackCommControlBlock.vue?vue&type=style&index=0&id=190651dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190651dc",
  null
  
)

export default component.exports